import React, { useState } from 'react'

import BalanceAndBudgetHeader from '../components/BalanceAndBudgetHeader'
import { PlanYearPicker } from '../components/PlanYearPicker/PlanYearPicker'
import TransactionsCard from '../components/TransactionsCard/TransactionsCard'
import { UnrecoverableErrorBanner } from '../components/UnrecoverableErrorBanner'

interface MemberTransactionsPageProps {
  planYears: number[]
}

const MemberTransactionsPageImpl: React.FC<MemberTransactionsPageProps> = ({ planYears }) => {
  // Always default to the current plan year
  let initialPlanYear = new Date().getFullYear()
  if (!planYears.includes(initialPlanYear)) {
    // If current plan year is not found, try to grab the one from planYears if exists
    initialPlanYear = planYears.length > 0 ? Math.max(...planYears) : 0
  }
  const [selectedPlanYear, setSelectedPlanYear] = useState<number>(initialPlanYear)

  if (planYears.length === 0) {
    return (
      <div className='flex flex-col w-full gap-6'>
        <UnrecoverableErrorBanner />
      </div>
    )
  }

  const handlePlanYearChange = (year: number) => {
    setSelectedPlanYear(year)
  }

  return (
    <div className='flex flex-col w-full gap-6'>
      <div className='flex flex-row w-full justify-between items-center'>
        <h1 className='heading-lg text-main'>Transactions</h1>
        {/*
          * The fixed height here is a trick to prevent the buttons from
          * increasing the height of the header's content box. This prevents
          * the page heading from jumping when navigating to and from pages
          * that don't have buttons in their header.
          */}
        <div className='flex flex-row items-center md:h-8'>
          <PlanYearPicker
            planYears={planYears}
            selectedPlanYear={selectedPlanYear}
            onPlanYearChange={handlePlanYearChange}
          />
        </div>
      </div>
      <BalanceAndBudgetHeader
        planYear={selectedPlanYear}
        isForTransactionsPage
      />
      <TransactionsCard planYear={selectedPlanYear} />
    </div>
  )
}

export const MemberTransactionsPage: React.FC<MemberTransactionsPageProps> = (props) => {
  return (
    <MemberTransactionsPageImpl {...props} />
  )
}

export default MemberTransactionsPage
